import { useCallback } from "react"
import { dashboardEvents, DASHBOARD_EVENTS } from "helpers/events/dashboard-events"
import { useAppDispatch } from "hooks/redux"
import { useDashboardId } from "../context/dashboard-id"
import { panelsSlice } from "../store/panels-slice"
import { cleanupPanelSlices } from "../store/cleanup-panel-slices"
import { type DashboardModule } from "../modules/types"

/**
 * Returns a stable removeModule function that emits MODULE_REMOVED before
 * dispatching to the panels slice. Keeps slice reducers pure.
 */
export function useRemoveModule(): (module: DashboardModule) => void {
  const dispatch = useAppDispatch()
  const dashboardId = useDashboardId()

  return useCallback(
    (module: DashboardModule) => {
      // Intentional: emit before dispatch so listeners can still read the module from the live store
      dashboardEvents.emit(DASHBOARD_EVENTS.MODULE_REMOVED, module)
      cleanupPanelSlices(dispatch, dashboardId, module)
      dispatch(panelsSlice.actions.removeModule({ dashboardId, moduleId: module.id }))
    },
    [dispatch, dashboardId],
  )
}
